/**
 * Negativlisten-Normalisierung (02 „Auswahl“): NFKC, deutsche Kleinschreibung,
 * Teilzeichenfolge, keine regulären Ausdrücke. Identisch in Nidus (byte-gleiche Kopie).
 */
export function normalizeTerm(input) {
    return input.normalize('NFKC').toLocaleLowerCase('de-DE').replace(/\s+/g, ' ').trim();
}
export function normalizeText(input) {
    return input.normalize('NFKC').toLocaleLowerCase('de-DE').replace(/\s+/g, ' ');
}
/** Leere Begriffe verboten, normalisierte Dubletten zusammengeführt, stabil sortiert. */
export function normalizeTerms(inputs) {
    const set = new Set();
    for (const raw of inputs) {
        const n = normalizeTerm(raw);
        if (n.length > 0)
            set.add(n);
    }
    return [...set].sort();
}
export function findTermHits(text, normalizedTerms) {
    const hay = normalizeText(text);
    const hits = [];
    for (const term of normalizedTerms) {
        const index = hay.indexOf(term);
        if (index >= 0)
            hits.push({ term, index });
    }
    return hits;
}
//# sourceMappingURL=exclusion.js.map